module.exports = __webpack_public_path__ + "static/img/李剑.67f7462.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/teacher/李剑.jpg
// module id = 661F
// module chunks = 139